module.exports = __webpack_public_path__ + "static/advantage_product2-e3de21ddf49b6419e85e533132fa557e.jpg";